import { and, isEnumControl, JsonFormsRendererRegistryEntry, rankWith, optionIs } from '@jsonforms/core';
import controlRenderer from './EnumControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(20, and(isEnumControl, optionIs('version', 'v2'))),
};
